import { render, staticRenderFns } from "./ESGModulePieChart.vue?vue&type=template&id=2325163b&scoped=true"
import script from "./ESGModulePieChart.vue?vue&type=script&lang=js"
export * from "./ESGModulePieChart.vue?vue&type=script&lang=js"
import style0 from "./ESGModulePieChart.vue?vue&type=style&index=0&id=2325163b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2325163b",
  null
  
)

export default component.exports